<template>
	<div class="lnk-quickfilter-item">
		<label class="filter-label">
			<span>{{filter.name}}:</span>
		</label>
		<div class="filter-content">
			<el-radio-group
				@change="handleChange"
				v-if="type==='block'"
				v-model="results[index]">
				<el-radio class="start" :label="null" v-show="!filter.notShowAll">全部</el-radio>
				<el-radio
					v-for="(item, sindex) in p_options"
					:label="item.val"
					:key="item.id && sindex"
				>{{item.name}}
				</el-radio>
			</el-radio-group>
			<el-radio-group
				@change="handleChange"
				v-if="type==='radio'"
				v-model="results[index]">
				<div class="fixmargin-top"></div>
				<el-radio class="start" :label="null" v-show="!filter.notShowAll">全部</el-radio>
				<el-radio
					v-for="(item,sindex) in p_options"
					:label="item.val"
					:key="item.id || sindex"
				>{{item.name}}
				</el-radio>
			</el-radio-group>
			<div v-if="type==='check'" class="check-row">
				<div class="fixmargin-top"></div>
				<el-checkbox
					class="checkall start"
					v-model="checkall[index]"
					:indeterminate="getIndeterminate(index)"
					@change="function(val){
                                onCheckAll(val,index);
                                handleChange();
                            }">全部
				</el-checkbox>
				<el-checkbox-group
					@change="handleChange"
					v-model="results[index]">
					<el-checkbox
						v-for="(item,sindex) in p_options"
						:label="item.val"
						:key="item.id || sindex"
					>{{item.name}}
					</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
	export default {
		name: "lnk-quickfilter-item",
		props: {
			filter: {},
			index: {},
			type: {},
			handleChange: {},
			results: {},
			getIndeterminate: {},
			checkall: {},
			onCheckAll: {},
			options: {},
		},
		watch: {
			options: {
				immediate: true,
				async handler(val) {
					if (this.$lv.$utils.typeOf(val) === 'promise') {
						this.p_options = await val
					} else {
						this.p_options = val
					}
				},
			},
		},
		data() {
			return {
				p_options: null,
			}
		},
	}
</script>

<style lang="scss">
	.lnk-quickfilter-item {
		.filter-label {
			font-size: 12px;
			color: rgba(0, 0, 0, 0.85) !important;
			letter-spacing: 1px;
			font-weight: 500;
		}

		.el-checkbox__label {
			font-size: 12px;
			color: rgba(0, 0, 0, 0.65) !important;
			letter-spacing: 0;
		}
	}
</style>
